import React from "react";
import { Field } from "redux-form";
import { TextArea } from "MODULES/shared/components/Forms/";

export default function NotesSection({ disabled }) {
  return [
    <hr className="hr-sm" key={0} />,
    <h5 className="h4" key={1}>
      Notes
    </h5>,
    <div className="row row-col-gutters-half" key={2}>
      <div className="col-md-6">
        <Field
          name="internal_note"
          rows={5}
          cols={50}
          component={TextArea}
          label="Internal Note"
          disabled={disabled}
        />
      </div>
      <div className="col-md-6">
        <Field
          name="external_note"
          rows={5}
          cols={50}
          component={TextArea}
          label="External Note"
          disabled={disabled}
        />
      </div>
    </div>
  ];
}



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/NotesSection.jsx